import Component from './component';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Navigation/components/NavigationLink/index.js